import React from "react";
import Animation from "./Animation";
import { FaInstagram } from "react-icons/fa";
import { useLanguage } from '../i18n/translations';

export default function Footer({ categories }) {
    const { translate } = useLanguage();
    return (
        <div className="mt-24">
            <div className="w-full overflow-hidden mb-[-110px] sm:mb-[-180px] z-[100] relative">
                <Animation />
            </div>
            <div className="z-[1] mt-[-5px]">
                <svg viewBox="0 0 1440 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 43.9999C106.667 43.9999 213.333 7.99994 320 7.99994C426.667 7.99994 533.333 43.9999 640 43.9999C746.667 43.9999 853.333 7.99994 960 7.99994C1066.67 7.99994 1173.33 43.9999 1280 43.9999C1386.67 43.9999 1440 19.0266 1440 9.01329V100H0V43.9999Z"
                        className="fill-current text-bgSkin"
                    />
                </svg>

                <div className="bg-bgSkin">
                    <div className="max-w-6xl mx-auto px-6 pt-4 pb-12">
                        <div className="grid grid-cols-1 938:grid-cols-4 gap-10 938:gap-8">

                            {/* Logo + tagline */}
                            <div className="flex flex-col items-center 938:items-start gap-3">
                                <img src="/images/logo.png" className="w-20" alt="Bulka Ceramics Logo" />
        
                                <a
                                    href="https://www.instagram.com/bulkaceramics"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-1 flex items-center gap-2 text-brownSkin hover:text-black transition-colors duration-200 group"
                                >
                                    <FaInstagram size={20} className="group-hover:scale-110 transition-transform duration-200" />
                                    <span className="text-sm font-medium">@bulkaceramics</span>
                                </a>
                            </div>

                            {/* Proizvodi */}
                            <div className="flex flex-col items-center 938:items-start gap-3">
                                <h3 className="text-brownSkin font-semibold text-sm tracking-widest uppercase">{translate("Products")}</h3>
                                <div className="w-8 h-px bg-brownSkin opacity-40" />
                                <ul className="space-y-2">
                                    {categories.map(category => (
                                        <li key={category.id}>
                                            <a
                                                className="text-sm text-gray-700 hover:text-brownSkin transition-colors duration-200"
                                                href={`/kategorija/${category.path}`}
                                            >
                                                {category.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Informacije */}
                            <div className="flex flex-col items-center 938:items-start gap-3">
                                <h3 className="text-brownSkin font-semibold text-sm tracking-widest uppercase">{translate("Information")}</h3>
                                <div className="w-8 h-px bg-brownSkin opacity-40" />
                                <ul className="space-y-2">
                                    {/* Poslovni pokloni — privremeno sklonjeno sa sajta.
                                    <li><a className="text-sm text-gray-700 hover:text-brownSkin transition-colors duration-200" href="/korporativni-pokloni">{translate("Business Gifts")}</a></li>
                                    */}
                                    <li><a className="text-sm text-gray-700 hover:text-brownSkin transition-colors duration-200" href="/dostava">{translate("Delivery & Returns")}</a></li>
                                    <li><a className="text-sm text-gray-700 hover:text-brownSkin transition-colors duration-200" href="/politika-privatnosti">{translate("Privacy Policy")}</a></li>
                                    <li><a className="text-sm text-gray-700 hover:text-brownSkin transition-colors duration-200" href="/uslovi-koriscenja">{translate("Terms of Use")}</a></li>
                                </ul>
                            </div>

                            {/* Kontakt */}
                            <div className="flex flex-col items-center 938:items-start gap-3">
                                <h3 className="text-brownSkin font-semibold text-sm tracking-widest uppercase">{translate("Contact")}</h3>
                                <div className="w-8 h-px bg-brownSkin opacity-40" />
                                <a
                                    href="mailto:contact@bulkaceramics.com"
                                    className="text-sm text-gray-700 hover:text-brownSkin transition-colors duration-200 break-all"
                                >
                                    contact@bulkaceramics.com
                                </a>
                                <a
                                    href="mailto:contact@bulkaceramics.com"
                                    className="mt-1 inline-block border border-brownSkin text-brownSkin text-sm px-5 py-2 hover:bg-brownSkin hover:text-white transition-all duration-200 tracking-wide"
                                >
                                    {translate("Contact us")}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Bottom bar */}
                    <div className="border-t border-brownSkin border-opacity-20">
                        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-center">
                            <span className="text-xs text-gray-500 tracking-wide">© 2026 Bulka Ceramics. {translate("All rights reserved.")}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
